import { render, staticRenderFns } from "./NshopOrderList.vue?vue&type=template&id=08033acc&scoped=true&"
import script from "./NshopOrderList.vue?vue&type=script&lang=js&"
export * from "./NshopOrderList.vue?vue&type=script&lang=js&"
import style0 from "./NshopOrderList.vue?vue&type=style&index=0&id=08033acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08033acc",
  null
  
)

export default component.exports